export const ROUTE_IDENTIFIER_NAMES = {
  HOME: 'HOME',
  PERMISSIONS: 'PERMISSIONS',
  INTEGRATIONS: 'INTEGRATIONS',
  INTEGRATIONS_SQEPTECH: "INTEGRATIONS_SQEPTECH",
  INTEGRATIONS_CPR: "INTEGRATIONS_CPR",
  INTEGRATIONS_CPR_MANAGE_CREDENTIALS: "INTEGRATIONS_CPR_MANAGE_CREDENTIALS",
  INTEGRATIONS_LESSOR: "INTEGRATIONS_LESSOR",
  INTEGRATIONS_VISMA: "INTEGRATIONS_VISMA",
  INTEGRATIONS_UNIT4: "INTEGRATIONS_UNIT4",
  INTEGRATIONS_TETA: "INTEGRATIONS_TETA",
  INTEGRATIONS_PROMARK: "INTEGRATIONS_PROMARK",
  INTEGRATIONS_TMS: "TMS",
  INTEGRATIONS_DALCOAFAS: "INTEGRATIONS_DALCOAFAS",
  INTEGRATIONS_FOPPENAFAS: "INTEGRATIONS_FOPPENAFAS",
} as const satisfies Record<string, string>;

export type RouteIdentifierNames =
  (typeof ROUTE_IDENTIFIER_NAMES)[keyof typeof ROUTE_IDENTIFIER_NAMES];
